import Vue from 'vue';
import store from './../../store';

// Phase E/F — fetches the monolith's view of inventory bridge handoff state
// for the current org. Shape:
//   { stock_mutations_handed_off, stock_decommissioned,
//     fulfillment_callbacks_enabled, inventory_app_url, organization_id }
//
// A failure here (e.g. bridge flag off, network error) is treated as "no
// handoff" — the caller falls through to the legacy monolith UI.
export default () => (
  new Promise((resolve) => {
    Vue.$http.get('/inventory-bridge/handoff-state')
      .then((response) => {
        const payload = (response && response.data && response.data.data) || {};
        if ((payload.stock_mutations_handed_off || payload.stock_decommissioned) && !payload.inventory_app_url) {
          // eslint-disable-next-line no-console
          console.warn('[bridgeHandoff] org is handed off but INVENTORY_APP_URL is empty in the monolith env — banner will render without an "Open Inventory App" link.');
        }
        store.dispatch('setBridgeHandoff', payload);
        resolve(payload);
      })
      .catch(() => {
        // false signals "fetched, bridge not available" — distinct from null
        // ("never fetched") so the route guard doesn't retry on every navigation.
        store.dispatch('setBridgeHandoff', false);
        resolve(null);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/bridgeHandoff/fetch.js